import { BASE_QUESTIONS, type BaseQuestionId } from "../../shared/inquiry-flow";

interface ProgressProps {
  currentQuestionId: BaseQuestionId | null;
  readyForContact: boolean;
}

export function Progress({
  currentQuestionId,
  readyForContact,
}: ProgressProps) {
  const currentIndex = currentQuestionId
    ? BASE_QUESTIONS.findIndex((question) => question.id === currentQuestionId)
    : BASE_QUESTIONS.length;
  const displayedPosition = readyForContact
    ? BASE_QUESTIONS.length
    : Math.max(1, currentIndex + 1);

  return (
    <div
      className="progress-block"
      aria-label={`基本質問 ${displayedPosition}/4`}
    >
      <div className="question-steps" aria-hidden="true">
        {BASE_QUESTIONS.map((question, index) => {
          const completed = readyForContact || index < currentIndex;
          const current = !readyForContact && index === currentIndex;
          return (
            <span
              className={`${completed ? "completed" : ""}${current ? " current" : ""}`.trim()}
              key={question.id}
            />
          );
        })}
      </div>
    </div>
  );
}
